import { Component } from '@angular/core';
import { ApiInvoice, InvoicesService } from 'src/app/services/invoices.service';

@Component({
  selector: 'app-api-invoices-page',
  templateUrl: './api-invoices-page.component.html',
  styleUrl: './api-invoices-page.component.scss',
})
export class ApiInvoicesPageComponent {
  loadingInvoices = false;
  // We are showing both pending and completed API invoices on this page
  pendingApiInvoices: ApiInvoice[] = [];
  completedApiInvoices: ApiInvoice[] = [];
  errorFetchingInvoices = '';

  constructor(private invoicesService: InvoicesService) {
    this.getApiInvoices();
  }

  getApiInvoices() {
    this.loadingInvoices = true;
    this.invoicesService.getApiInvoicesForCurrentTenant().subscribe({
      next: (res) => {
        console.log('API invoices for current tenant', res);
        this.loadingInvoices = false;
        this.pendingApiInvoices = res.api_invoices.pending;
        this.completedApiInvoices = res.api_invoices.complete;
        this.sortApiInvoices(this.pendingApiInvoices);
        this.sortApiInvoices(this.completedApiInvoices);
      },
      error: (err) => {
        this.loadingInvoices = false;
        console.error(err);
        this.errorFetchingInvoices = err;
      },
    });
  }

  sortApiInvoices(invoices: ApiInvoice[]) {
    invoices.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB.getTime() - dateA.getTime();
    });
  }

  getDisplayTransactionMonth(dateString: string): Date {
    return this.invoicesService.getDisplayTransactionMonth(dateString);
  }

  navigateToApiInvoice(invoice: ApiInvoice) {
    if (invoice.completed) {
      window.location.href = '/api-receipt/' + invoice.id;
    } else {
      window.location.href = '/api-checkout/' + invoice.id;
    }
  }
}
